module.exports = __webpack_public_path__ + "img/icon_success.c9ea9f9a.svg";